<template>
  <div class="login-button">
    <PrimaryBtn class="login-button__button" @click="showLogin">{{ label }}</PrimaryBtn>
    <transition name="show-in">
      <QrMask
        v-if="loginShowing"
        :title="$t('sign.login')"
        :tip1="$t('sign.loginQr')"
        :tip2="$t('sign.loginLink')"
        :qr="qrText"
        link="https://onto.app/"
        @close="handleClose"
      />
    </transition>
  </div>
</template>

<script>
import PrimaryBtn from '@/components/PrimaryBtn.vue';
import QrMask from '@/components/QrMask.vue';
import URLS from '@/config/url';
import { TIMES } from '@/config/enum';
import { handleLogin } from '@/utils/user';

export default {
  name: 'LoginButton',
  components: { QrMask, PrimaryBtn },
  props: {
    label: {
      type: String,
      require: false,
      default() {
        return this.$t('nav.signIn');
      },
    },
    showTip: {
      type: Boolean,
      require: false,
      default: false,
    },
  },
  data() {
    return {
      loginShowing: false,
      qrText: '',
      id: '',
      timer: null,
    };
  },
  methods: {
    showLogin() {
      this.loginShowing = true;
      this.fetchId();
    },
    handleClose() {
      this.loginShowing = false;
      clearTimeout(this.timer);
      this.id = '';
    },
    fetchId() {
      this.$request({
        url: URLS.registerId,
        params: {
          type: 'login',
        },
      }).then((res) => {
        this.id = res.id;
        this.qrText = JSON.stringify({
          ONTAuthScanProtocol: `${process.env.VUE_APP_BASE_API}/v1/ontauth/dataurl?type=login&messageId=${this.id}`,
        });
        this.startFetchStatus();
      });
    },
    startFetchStatus() {
      this.$request({
        url: URLS.loginStatus,
        params: {
          id: this.id,
        },
      }).then((res) => {
        if (!res.result) {
          this.timer = setTimeout(() => {
            this.startFetchStatus();
          }, TIMES.pollRequestTime);
        } else {
          handleLogin(res.result.token_type, res.result.access_token);
          this.$toast(this.$t('sign.loginSuccess'));
          this.$emit('login');
        }
      });
    },
  },
  beforeDestroy() {
    clearTimeout(this.timer);
  },
};
</script>

<style lang="scss">
  .login-button {
    display: inline-block;
    width: 240px;
  }

  .login-button__button {
    width: 100%;
    height: 100%;
  }
</style>
